module.exports = function() {
  return new Worker(__webpack_public_path__ + "628cd48764946ded1f1f.worker.js");
};